module.exports = __webpack_public_path__ + "static/media/star.81791581.svg";